import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ServicesList from './pages/ServicesList';
import ServiceDetail from './pages/ServiceDetail';
import IndustriesList from './pages/IndustriesList';
import IndustryDetail from './pages/IndustryDetail';
import MarketDetail from './pages/MarketDetail';
import Locations from './pages/Locations';
import CityDetail from './pages/CityDetail';
import CaseStudies from './pages/CaseStudies';
import CaseStudyDetail from './pages/CaseStudyDetail';
import Resources from './pages/Resources';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Author from './pages/Author';
import About from './pages/About';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import FluidBackground from './components/FluidBackground';
import ChatWidget from './components/ChatWidget';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <ScrollToTop />
        <FluidBackground />
        <Navbar />
        <main className='relative z-10'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/services' element={<ServicesList />} />
            <Route path='/services/:slug' element={<ServiceDetail />} />
            <Route path='/industries' element={<IndustriesList />} />
            <Route path='/industries/:slug' element={<IndustryDetail />} />
            <Route path='/markets/:slug' element={<MarketDetail />} />
            <Route path='/locations' element={<Locations />} />
            <Route path='/locations/:slug' element={<CityDetail />} />
            <Route path='/case-studies' element={<CaseStudies />} />
            <Route path='/case-studies/:slug' element={<CaseStudyDetail />} />
            <Route path='/resources' element={<Resources />} />
            <Route path='/blog' element={<Blog />} />
            <Route path='/blog/:slug' element={<BlogPost />} />
            <Route path='/authors/:slug' element={<Author />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <ChatWidget />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
